module.exports = __webpack_public_path__ + "media/images/athletes/3851-2eaa0e002734aba2d482c3db3d24463d.png";